import React, { Component } from 'react'
import { IRolesProps } from '../../models/components/roles';
import Translator from '../../core/i18n';
import { Common } from '../../core/common';
const T = Translator.create();
let _common: Common;

export class Roles extends Component<IRolesProps> {
    constructor(props?: any) {
        _common = new Common();
        super(props);
    }
  render() {
    return (
<div className='row pt-3 '>
                            <div className='col-md-12 p-0 m-0' >
                            <div className='row' style={{marginInlineStart: "1.5rem"}}>
                                
                            <div className='col-md-9 p-0 m-0 role-div' onMouseDown={e => this.props.editRoleFunc( this.props.data.id, this.props.roleType)}>
                                <div className='row' style={{paddingInlineStart: "4px"}}>
                                <div className='col-10' >{this.props.data.name}</div>
                                <div className='col-2 role-div-notification'>{this.props.data.users.length}</div>
                                    </div>
                                </div>
                            <div className='col-md-3 p-0 m-0 pt-1'>
                            
                            <div className='role-div-dots' style={{display: "inline-block"}} data-toggle="dropdown" >
                            <img src={_common.GetDefaultImages('_dots')} className="m-t-15" alt="" />
                            </div>  

                            
                            <div
                    className="dropdown-menu shadow"
                    aria-labelledby="dropdownMenuButton"
                    style={{
                        position: 'absolute',
                        transform: ' translate3d(-165px, 22px, 0px); top: 0px; left: 0px; will-change: transform'
                    }}
                >
                
                
                <a className={`dropdown-item`} onMouseDown={this.props.triggerRoleModal}>{T.t('r_gen_edit')}</a>
                <a className={`dropdown-item`} onMouseDown={e => this.props.viewUsers(!this.props.viewUsersModal, this.props.data.id, this.props.roleType)}>{T.t('r_system_roles_view_users')}</a>
                <a className={`dropdown-item`} onMouseDown={this.props.triggerRoleModal}>{T.t('r_system_roles_create_copy')}</a>
                <div className="dropdown-divider" />
                            <p
                             onMouseDown={this.props.deleteModal}
                                className="dropdown-item text-danger mb-1"
                                style={{ cursor: 'pointer', paddingTop: 4 + 'px !important' }}
                            >
                                {T.t('r_system_roles_delete_role')}
                            </p>
                
            
                            </div>



                            </div>
                            </div>
                            </div>
                            
                        </div>
    )
  }
}

export default Roles